import type { ReactNode } from "react";

export const ModelFormColumn = ({ children }: { children: ReactNode }) => (
  <div className="flex-col w-[500px] md:w-[600px]">{children}</div>
);
